var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-base-application',{attrs:{"title":"よくある質問（FAQ）"}},[_c('faq-list',{attrs:{"is-management":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }